import { useContext } from 'react'
import StaticDataContext from './StaticDataContext'

export const useStaticData = <T>() => useContext(StaticDataContext) as T
